import AssignmentLate from '@material-ui/icons/AssignmentLate';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import { PvCheckbox } from 'components/form/PvCheckbox';
import PvBadge from 'components/PvBadge.jsx';
import { updateApplicants } from 'ducks/theoryLessons';
import { getApplicantAction } from 'ducks/workItem';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex, Text } from 'rebass';
import { bindActionCreators, compose } from 'redux';
import * as sort from 'sortabular';
import styled from 'styled-components';
import { PvBox, PvCaret, PvLinkGreen, PvLinkGreenCap } from 'styles/CustomComponents';
import { resolve } from 'table-resolver';
import { arrayToCsv } from 'util/FormatUtil';

const PvUndone = styled(AssignmentLate)`
  color: ${props => props.theme.colors.berryRed};
  fontSize: 28px;
  cursor:pointer;
`;

const PvAssign = styled(AssignmentTurnedIn)`
  color: ${props => props.theme.colors.green};
  fontSize: 28px;
  cursor:pointer;
`;

const BOXNAME = Object.freeze({
  SELECTED: 'selected',
  UNDONE: 'undone',
});

const PvUndoneWrapper = (params) => {
  return  <div onClick={() => (toggleAllApplicants(params.filters, params.applicants, params.updateApplicants, BOXNAME.UNDONE, BOXNAME.SELECTED))}><PvUndone/></div>
};

const PvAssignWrapper = (params) => {
  return <div onClick={() => (toggleAllApplicants(params.filters, params.applicants, params.updateApplicants, BOXNAME.SELECTED, BOXNAME.UNDONE))}><PvAssign/></div>
};

//Returns if all boxes should be checked or unchecked.
//If everything is already selected -> unselect, else select all.
const isSelectAll = (applicants, selectParam) => {
  let allAlreadyChecked = true;
  for (let i = 0; i < applicants.length; i++) {
    if (applicants[i][selectParam] !== true) {allAlreadyChecked = false; break;}
  }
  return !allAlreadyChecked;
};

const assignApplicantSelection = (applicant, value, propertyToSet, propertyToUnset) => {
  const newState = {};
  newState[propertyToSet] = value;
  newState[propertyToUnset] = false;
  return Object.assign(applicant, newState);
}

const toggleAllApplicants = (filters, allApplicants, updateApplicants, propertyToToggle, propertyToUnset) => {
  const visibleApplicants = filteredRows(filters, allApplicants);
  const visibleApplicantIds = new Set(visibleApplicants.map(applicant => applicant.entityId));
  const selectAll = isSelectAll(visibleApplicants, propertyToToggle);
  const updatedApplicants = allApplicants.map( applicant => {
    if(visibleApplicantIds.has(applicant.entityId)) {
      return assignApplicantSelection(applicant, selectAll, propertyToToggle, propertyToUnset);
    }
    return applicant;
  });
  updateApplicants(updatedApplicants);
};

const toggleApplicant = (applicants, applicant, propertyToToggle, propertyToUnset, updateApplicants) => {
  const i = applicants.map((a) => a.entityId).indexOf(applicant.entityId);
  if(i >= 0) {
    const applicant = applicants[i];
    const newStateForPoperty = !applicant[propertyToToggle];
    const updatedApplicants = [
      ...applicants.slice(0, i),
      assignApplicantSelection(applicant, newStateForPoperty, propertyToToggle, propertyToUnset),
      ...applicants.slice(i + 1),
    ];
    updateApplicants(updatedApplicants);
  }
};

const courseNumberFits = (courseNumber, courseNumberFilter) => {
  const numberArr = courseNumberFilter.split(";").filter(number => number !== "");
  return numberArr.filter(number => number === courseNumber).length > 0
};

const applyFilters = ({filters} = {}) => (rows) => {
  if (!rows.length)
    return [];
  if (!!filters.courseNumber)
    rows = rows.filter(r => !!r.course && courseNumberFits(r.course.courseNumber, filters.courseNumber));
  if (!!filters.courseYear)
    rows = rows.filter(r => !!r.course && r.course.courseYear === filters.courseYear);
  if (!!filters.courseUnit)
    rows = rows.filter(r => !!r.course && r.course.courseUnit === filters.courseUnit);
  if (!!filters.team)
    rows = rows.filter(r => !!r.team && r.team.toLowerCase() === filters.team.toLowerCase());
  if (!!filters.onlyUndone && !!filters.selectedLessons) {
    const selectedLessonIds = filters.selectedLessons.map(l => l.entityId);
    rows = rows.filter(r=> r.previousUndone.some(undone=> selectedLessonIds.includes(undone)));
  }
  if (!!filters.name)
    rows = rows.filter(r => {
      let searchTerm = filters.name.toLowerCase().trim();

      if (~searchTerm.indexOf(' ')) {
        searchTerm = searchTerm.split(' ');

        return (~r.firstNames.toLowerCase().indexOf(searchTerm[0]) || ~r.lastName.toLowerCase().indexOf(searchTerm[0])) &&
          (~r.firstNames.toLowerCase().indexOf(searchTerm[1]) || ~r.lastName.toLowerCase().indexOf(searchTerm[1]));
      }

      return ~r.firstNames.toLowerCase().indexOf(searchTerm) || ~r.firstNames.toLowerCase().indexOf(searchTerm) ||
        ~r.lastName.toLowerCase().indexOf(searchTerm);
    });
  return rows;
};

const filteredRows = (filters, rows) => applyFilters({filters})(rows)

class TheoryApplicantsDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};
    const updateApplicants = (applicants) => this.props.updateApplicants(applicants);

    const toggleSelection = (applicants, applicant) => toggleApplicant(applicants, applicant, BOXNAME.SELECTED, BOXNAME.UNDONE, updateApplicants);
    const toggleUndone = (applicants, applicant) => toggleApplicant(applicants, applicant, BOXNAME.UNDONE, BOXNAME.SELECTED, updateApplicants);
    



    const highlight = (lessons, type) => {
      const lessonsState = lessons.reduce((obj, key) => ({ ...obj, [key]: type}), {});
      this.props.highlightFn(lessonsState);
    };

    const sortable = sort.sort({
      getSortingColumns,
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      },
      strategy: sort.strategies.byProperty
    });

    const columns = [
      {
        property: 'undone',
        header: {
          label: <PvUndoneWrapper applicants = {this.props.rows} filters = {this.props.filters} updateApplicants = {updateApplicants} />,
        },
        props: {
          style: {
            width: '3em',
          }
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <PvCheckbox color='#603' defaultChecked={value} onChange={() => {
                  toggleUndone(this.props.rows, props.rowData);
                }} />);
            }
          ],
          transforms: [
            (value, props) => {
              if (!props.rowData.hasOwnProperty('undone')) {
                Object.assign(props.rowData, {undone: false});
              }
            }
          ]
        }
      },
      {
        property: 'selected',
        header: {
          label: <PvAssignWrapper applicants = {this.props.rows} filters = {this.props.filters} updateApplicants = {updateApplicants} />,
        },
        props: {
          style: {
            width: '3em'
          }
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <PvCheckbox type="checkbox" checked={value} onChange={() => {
                  toggleSelection(this.props.rows, props.rowData);
                }} />);
            }
          ],
          transforms: [
            (value, props) => {
              if (!props.rowData.hasOwnProperty('selected')) {
                Object.assign(props.rowData, {selected: false});
              }
            }
          ]
        }
      },
      {
        property: 'lastName',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='app.name' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <Text>
                  <PvLinkGreen href='#' onClick={(e) => {
                    e.preventDefault();
                    this.props.getApplicant(props.rowData.entityId);
                  }}>
                    {props.rowData.lastName}
                  </PvLinkGreen>
                  &nbsp;
                  <PvLinkGreenCap href='#' onClick={(e) => {
                    e.preventDefault();
                    this.props.getApplicant(props.rowData.entityId);
                  }}>
                    {props.rowData.firstNames}
                  </PvLinkGreenCap>
                </Text>
              );
            }
          ],
        }
      },
      {
        property: 'trafiId',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='app.trafi_id' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        }
      },
      {
        property: 'civilDrivingLicenses',
        header: {
          label: <Translate value='app.civil_driving_licenses' />
        },
        cell: {
          formatters: [
            (value, props) => {
              if (value && value.length > 0) {
                return arrayToCsv(value);
              } else {
                return '-';
              }
            }
          ]
        }
      },
      {
        header: {
          label: ''
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <div>
                  {props.rowData.previousUndone.length > 0 &&
                  <PvBox
                    display='inline-block'
                    onMouseEnter={() => highlight(props.rowData.previousUndone, 'undone')}
                    onMouseLeave={() => highlight([])} >
                    <PvBadge type='PASSIVE' i18nMessage='app.previous_undone' />
                  </PvBox>
                  }
                  {props.rowData.previousComplete.length > 0 &&
                  <PvBox
                    display='inline-block'
                    onMouseEnter={() => highlight(props.rowData.previousComplete, 'complete')}
                    onMouseLeave={() => highlight([])} >
                    <PvBadge type='ACTIVE' i18nMessage='app.previous_complete' />
                  </PvBox>
                  }
                </div>
              );
            }
          ]
        }
      },
    ];

    this.state = {
      // Default sorting
      sortingColumns: {
        'lastName': {
          direction: 'asc',
          position: 0
        },
      },
      columns,
      rows: resolve({columns})(this.props.rows || [])
    };
  }

  componentWillReceiveProps(props) {
    this.setState({rows: props.rows});
  }

  render() {

    const {
      stylingRenderers,
      rowKey,
      filters
    } = this.props;

    const {sortingColumns, columns, rows} = this.state;
    const finalRows = compose(
      sort.sorter({
        columns,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty
      }),
      applyFilters({filters})
    )(rows);

    //Forces table to update. Source: https://reactabular.js.org/#/table/overriding-should-component-update
    //Causes "Warning: Stateless function components cannot be given refs. Attempts to access this ref will fail." in which no solution was found
    const BodyWrapper = props => <tbody {...props} />;
    BodyWrapper.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
      return true;
    };
    let renderers = Object.assign(stylingRenderers, {body: Object.assign(stylingRenderers.body, {wrapper: BodyWrapper})});

    return (
      <Table.Provider
        renderers={renderers}
        columns={columns}>
        <Table.Header />
        <Table.Body rows={finalRows} rowKey={rowKey || 'entityId'} />
      </Table.Provider>
    );
  }
}

TheoryApplicantsDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  getApplicant: PropTypes.func,
  highlightFn: PropTypes.func,
  stylingRenderers: PropTypes.object,
  filters: PropTypes.object,
  rowKey: PropTypes.string,
  currentCourse: PropTypes.object,
};

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  updateApplicants: (applicants) => updateApplicants(applicants),
  getApplicant: (id) => getApplicantAction(id, ownProps.currentCourse),
}, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(TheoryApplicantsDataTable);


// WEBPACK FOOTER //
// ./src/components/datatable/TheoryApplicantsDataTable.jsx